<template>
    <div class="change_main">
        <div class="main_menu">
            <ul class="main_menu_ul" @click="showMenu">
                <li :key="topIndex" class="li_border" v-for="(topItem,topIndex) in topList">
                    <a href="#">{{topItem.topName}}
                        <div class="li_arrow"></div>
                    </a>
                    <div class="sub_menu">
                        <ul class="sub_menu_ul" v-if="topItem.companyList">
                            <li :key="liIndex" v-for="(liItem,liIndex) in topItem.companyList"><a href="#">{{liItem.comName}}</a></li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
        <div class="main_middle"></div>
    </div>
</template>

<script>
    export default {
        methods: {
            showMenu() {
            }
        },
        data() {
            return {
                topList: [
                    {
                        topName: '智能排序',
                        companyList: [
                            {
                                index: 0,
                                comName: '智能排序'
                            },
                            {
                                index: 1,
                                comName: '商品价格'
                            },
                            {
                                index: 2,
                                comName: '商品名称'
                            },
                            {
                                index: 3,
                                comName: '上架时间'
                            }
                        ]
                    },
                    {
                        topName: '选择公司',
                        companyList: []
                    }
                ]
            };
        }
    };
</script>

<style lang="scss" scoped>
    .change_main {
        height: 100%;
        width: 100%;
        background: #F7FAFA;
        position: absolute;
    }

    .main_menu {
        position: fixed;
        z-index: 998;
        width: 100%;
        height: 45px;
        font-size: 14px;
        background: white;
        -moz-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); /*firefox*/
        -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); /*safari或chrome*/
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); /*opera或ie9*/
    }

    .main_middle {
        width: 100%;
        height: 100%;
    }

    .main_menu_ul {
        width: 100%;
        line-height: 45px;
    }

    .main_menu_ul li {
        float: left;
        height: 45px;
        width: 50%;
    }

    .main_menu_ul li a {
        line-height: 45px;
        text-align: center;
        color: #596c83;
        font-size: 14px;
        padding-right: 15px;
        position: relative;
    }

    .li_arrow {
        position: absolute;
        top: 7px;
        right: 2px;
        width: 0;
        height: 0;
        overflow: hidden;
        border-right: 5px solid transparent;
        border-left: 5px solid transparent;
        border-top: 5px solid #e9e9e9;
        transition: all 0.5s ease 0s;
    }

    .main_menu_ul li:focus .li_arrow {
        -ms-transform: rotate(180deg); /* IE 9 */
        -moz-transform: rotate(180deg); /* Firefox */
        -webkit-transform: rotate(180deg); /* Safari 和 Chrome */
        -o-transform: rotate(180deg); /* Opera */
        transform: rotate(180deg);

        -webkit-transition: -webkit-transform 0.2s ease-in; /* Safari 和 Chrome */
        -moz-transition: -moz-transform 0.2s ease-in; /* Firefox */
        -o-transition: -o-transform 0.2s ease-in; /* Opera */
        transition: transform 0.2s ease-in;
    }

    .li_border {
        border-left: 0.5px solid #e9e9e9;
    }

    .sub_menu {
        display: none;
        position: absolute;
        z-index: 9;
        left: 0;
        top: 46px;
        width: 100%;
        background: white;
        overflow: hidden;
        -moz-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); /*firefox*/
        -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); /*safari或chrome*/
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); /*opera或ie9*/
    }


    .sub_menu_ul {
        width: 100%;
    }

    .sub_menu_ul li {
        float: left;
        height: 45px;
        width: 100%;
        border-bottom: 0.5px solid #e9e9e9;
    }

    .sub_menu_ul li a {
        line-height: 45px;
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #596c83;
        padding-right: 15px;
        display: block;
    }
</style>
